import { render, staticRenderFns } from "./PortalHomeStep.vue?vue&type=template&id=fa80d520"
import script from "./PortalHomeStep.vue?vue&type=script&lang=js"
export * from "./PortalHomeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports